const translationsFr = {
    'contact-field-tooltip': 'Vous pouvez utiliser l\'un des noms de champs suivant : {{list}}. Vous pouvez également utiliser tout autre champ importé dans la liste de diffusion, par exemple : "Ville". Les majuscules/minuscules ne sont pas prises en compte.',
    'French': 'Français',
    'English': 'Anglais',
    'Name': 'Nom',
    'Process': 'Workflow',
    'General': 'Général',
    'Executable': 'Exécutable',
    'Element documentation': 'Description de l\'élément',
    'Translations': 'Traductions',
    'Activate hand tool': 'Activer l\'outil Main',
    'Activate lasso tool': 'Activer l\'outil Lasso',
    'Activate create/remove space tool': 'Activer l\'outil Créer/Supprimer un espace',
    'Activate global connect tool': 'Activer l\'outil de connexion globale',
    'Create start event': 'Créer un événement de début',
    'Create intermediate/boundary event': 'Créer un événement intermédiaire',
    'Create end event': 'Créer un événement de fin',
    'Create gateway': 'Créer une passerelle',
    'Create task': 'Créer une tâche (sans action)',
    'Create send task': 'Créer une tâche d\'envoi de message',
    'Create user task': 'Créer une tâche de changement de statut',
    'Create expanded sub-process': 'Créer un sous-processus étendu',
    'Create data object reference': 'Créer une référence d\'objet de données',
    'Create data store reference': 'Créer une référence de magasin de données',
    'Create pool/participant': 'Créer un pool/participant',
    'Create group': 'Créer un groupe',
    'Start Event': 'Événement de début',
    'Start event': 'Événement de début',
    'Append end event': 'Ajouter un événement de fin',
    'Append gateway': 'Ajouter une passerelle',
    'Append task': 'Ajouter une tâche (sans action)',
    'Append send task': 'Ajouter une tâche d\'envoi de message',
    'Append user task': 'Ajouter une tâche de changement de statut',
    'Append intermediate/boundary event': 'Ajouter un événement intermédiaire',
    'Add text annotation': 'Ajouter une annotation',
    'Change element': 'Modifier l\'élément',
    'Delete': 'Supprimer',
    'Connect to other element': 'Connecter à un autre élément',
    'Intermediate throw event': 'Événement intermédiaire',
    'Intermediate Throw Event': 'Événement intermédiaire',
    'End event': 'Événement de fin',
    'End Event': 'Événement de fin',
    'Text Annotation': 'Annotation',
    'Connect using association': 'Connecter en utilisant une association',
    'Parallel multi-instance': 'Instance multiple parallèle',
    'Sequential multi-instance': 'Instance multiple séquentielle',
    'Loop': 'Boucle',
    'Ad-hoc': 'Ad-hoc',
    'Task': 'Tâche (sans action)',
    'Send Task': 'Tâche d\'envoi de message',
    'Send task': 'Tâche d\'envoi de message',
    'User Task': 'Tâche de changement de statut',
    'User task': 'Tâche de changement de statut',
    'Default flow': 'Flux par défaut',
    'Default Flow': 'Flux par défaut',
    'Sequence Flow': 'Flux séquentiel',
    'Sequence flow': 'Flux séquentiel',
    'Conditional flow': 'Flux conditionnel',
    'Conditional Flow': 'Flux conditionnel',
    'Data Object Reference': 'Objet de données',
    'Data object reference': 'Objet de données',
    'Data Input Association': 'Association de données',
    'Data Store Reference': 'Magasin de données',
    'Data store reference': 'Magasin de données',
    'Exclusive Gateway': 'Passerelle exclusive',
    'Exclusive gateway': 'Passerelle exclusive',
    'Parallel Gateway': 'Passerelle parallèle',
    'Parallel gateway': 'Passerelle parallèle',
    'Connect using data input association': 'Connecter en utilisant une association de données',
    'Collection': 'Collection',
    'Participant': 'Participant',
    'Participant Name': 'Nom du participant',
    'ID': 'ID',
    'Participant ID': 'ID du participant',
    'Process ID': 'ID du workflow',
    'Process name': 'Nom du workflow',
    'Process documentation': 'Description du workflow',
    'Documentation': 'Description',
    'Collaboration': 'Collaboration',
    "Lane": "Section",
    "Add lane above": "Ajouter une section au dessus",
    "Add lane below": "Ajouter une section en dessous",
    "Divide into two lanes": "Diviser en deux sections",
    "Divide into three lanes": "Diviser en trois sections",
    "Empty pool/participant (removes content)": "Vider le pool/participant (supprime le contenu)",
    "Participant multiplicity": "Multiplicité du participant",
    'Group': 'Groupe',
    'Expanded Sub Process': 'Sous-processus étendu',
    'Multiple elements are selected. Select a single element to edit its properties.': 'Plusieurs éléments sont sélectionnés. Sélectionnez un seul élément pour modifier ses propriétés.',
    'Align elements': 'Aligner les éléments',
    'Align elements left': 'Aligner les éléments à gauche',
    'Align elements center': 'Aligner les éléments au centre',
    'Align elements right': 'Aligner les éléments à droite',
    'Align elements top': 'Aligner les éléments en haut',
    'Align elements middle': 'Aligner les éléments au milieu',
    'Align elements bottom': 'Aligner les éléments en bas',
    "Subject": "Objet",
    "E-mail content": "Contenu de l'e-mail",
    "Configure message": "Configurer le message",
    "Error end event": "Evénement de fin avec erreur",
    "Error End Event": "Evénement de fin avec erreur",
    "Form": "Formulaire",
    "Send form": "Envoyer un formulaire",
    "Configure form": "Configurer le formulaire",
    "Condition": "Condition",
    "If the form field...": "Si le champ du formulaire...",
    "If the contact field...": "Si le champ du contact...",
    "Otherwise (if no other condition has been met)": "Sinon (si aucune autre condition n'a été validée)",
    "Field": "Champ",
    "has value...": "a la valeur...",
    "does not have value...": "n'a pas la valeur...",
    "Value": "Valeur",
    "contains...": "contient...",
    "starts with...": "commence par...",
    "is empty": "est vide",
    "is not empty": "n'est pas vide",
    "is checked": "est coché",
    "is not checked": "n'est pas coché",
    "Trigger delay": "Délai de déclenchement",
    "days": "jours",
    "hours": "heures",
    "minutes": "minutes",
    "seconds": "secondes",
    "Contact": "Contact",
    "User who created the sendout": "Utilisateur qui a créé l'envoi",
    "Other email address": "Autre adresse e-mail",
    "Recipient": "Destinataire",
    "Email": "Adresse e-mail",
    "You can enter multiple email addresses separated by commas ','.": "Vous pouvez entrer plusieurs adresses e-mail séparées par des virgules ','.",
    "None": "Aucun",
    "New form": "Nouveau formulaire",
    "Create service task": "Créer une tâche de service externe",
    "Append service task": "Ajouter une tâche de service externe",
    "Service task": "Tâche de service externe",
    "Service Task": "Tâche de service externe",
    "External Service": "Service externe",
    "Action": "Action",
    "": "Ce champ est obligatoire",
    "No selection": "Aucune sélection",
    "Required field": "Champ obligatoire"
};

export default translationsFr;